import { LeagueId } from './index';

export const MUNDIAL_LEAGUE = 'mundial_fifa' as const satisfies LeagueId;

export type MundialMatchType =
  | 'group'
  | 'round_of_32'
  | 'round_of_16'
  | 'quarter_final'
  | 'semi_final'
  | 'third_place'
  | 'final';

export interface MundialTeam {
  id: string;
  league: typeof MUNDIAL_LEAGUE;
  name: string;
  code: string;
  group: string;
  flag_url: string;
  confederation?: string;
  /** Orden de fila en el Excel (por grupo) */
  sort_order?: number;
  created_at: Date;
  updated_at: Date;
}

export interface MundialTeamInput {
  name: string;
  code: string;
  group: string;
  flag_url: string;
  confederation?: string;
  sort_order?: number;
}

export interface GroupStandingRow {
  teamCode: string;
  teamName: string;
  flagUrl: string;
  played: number;
  won: number;
  drawn: number;
  lost: number;
  goalsFor: number;
  goalsAgainst: number;
  goalDifference: number;
  points: number;
  position: number;
}

export interface QualifiedTeam {
  teamCode: string;
  teamName: string;
  flagUrl: string;
  group: string;
  position: 1 | 2 | 3;
  slotKey: string;
}

export interface BracketMatchDisplay {
  id: string;
  bracketSlot: string;
  matchType: MundialMatchType;
  teamA: { name: string; code: string; flagUrl: string };
  teamB: { name: string; code: string; flagUrl: string };
  sourceLabelA?: string;
  sourceLabelB?: string;
  scoreA: number | null;
  scoreB: number | null;
  winnerCode: string | null;
  date: Date | null;
  stadium?: string;
  isPending: boolean;
}

export const MUNDIAL_GROUPS = [
  'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L',
] as const;

export type MundialGroupId = (typeof MUNDIAL_GROUPS)[number];
